module.exports = __webpack_public_path__ + "img/place_black_24dp.dee1fa4e.svg";